export default {"src":"/_next/static/media/FractureCareManagement.f9b8a89c.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};